import React, { useEffect, useState } from 'react';
import AdminLayout from '../../components/AdminLayout';
import API from '../../utils/api';

export default function AdminDashboard() {
  const [stats,  setStats]  = useState(null);
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    API.get('/admin/stats').then(r => setStats(r.data)).catch(() => {});
    API.get('/orders?limit=5').then(r => setOrders(r.data.orders || [])).catch(() => {});
  }, []);

  const cards = [
    { label: 'Total Revenue',  value: stats ? `₹${(stats.revenue/100000).toFixed(1)}L` : '—' },
    { label: 'Total Orders',   value: stats?.totalOrders   ?? '—' },
    { label: 'Products',       value: stats?.totalProducts ?? '—' },
    { label: 'Inquiries',      value: stats?.unreadInquiries ?? '—' },
  ];

  const statusColor = { placed:'#F57F17', confirmed:'#1565C0', processing:'#6A1B9A', shipped:'#0277BD', delivered:'#2E7D32', cancelled:'#C62828' };

  return (
    <AdminLayout title="Dashboard">
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 16, marginBottom: 32 }}>
        {cards.map(c => (
          <div key={c.label} style={{ background: 'white', border: '1px solid var(--border)', borderRadius: 4, padding: 20 }}>
            <div style={{ fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--text-light)', marginBottom: 8 }}>{c.label}</div>
            <div style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 36, fontWeight: 300, color: 'var(--maroon)' }}>{c.value}</div>
          </div>
        ))}
      </div>
      <h3 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 22, marginBottom: 16 }}>Recent Orders</h3>
      <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white', border: '1px solid var(--border)', borderRadius: 4 }}>
        <thead>
          <tr style={{ background: 'var(--cream)' }}>
            {['Order ID','Customer','Amount','Payment','Status'].map(h => (
              <th key={h} style={{ padding: '12px 16px', fontSize: 11, letterSpacing: 2, textTransform: 'uppercase', color: 'var(--text-light)', textAlign: 'left', borderBottom: '1px solid var(--border)' }}>{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {orders.length === 0 ? (
            <tr><td colSpan={5} style={{ padding: 32, textAlign: 'center', color: 'var(--text-light)', fontSize: 14 }}>No orders yet</td></tr>
          ) : orders.map(o => (
            <tr key={o._id} style={{ borderBottom: '1px solid var(--border)' }}>
              <td style={{ padding: '12px 16px', fontSize: 14 }}>#{o.orderId}</td>
              <td style={{ padding: '12px 16px', fontSize: 14 }}>{o.user?.name || o.guestName || 'Guest'}</td>
              <td style={{ padding: '12px 16px', fontSize: 14, fontWeight: 500, color: 'var(--maroon)' }}>₹{o.totalAmount?.toLocaleString()}</td>
              <td style={{ padding: '12px 16px', fontSize: 14, textTransform: 'capitalize' }}>{o.paymentMethod}</td>
              <td style={{ padding: '12px 16px' }}>
                <span style={{ fontSize: 11, padding: '3px 10px', borderRadius: 10, background: `${statusColor[o.orderStatus]}22`, color: statusColor[o.orderStatus] || '#555', textTransform: 'capitalize' }}>
                  {o.orderStatus}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </AdminLayout>
  );
}
